var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.637 13.8559C15.567 13.892 15.4883 13.9129 15.4045 13.9129C15.2107 13.9129 15.0423 13.8038 14.9539 13.6423L14.92 13.5664L13.5091 10.3968C13.4938 10.3623 13.4844 10.3233 13.4844 10.2854C13.4844 10.1393 13.6001 10.021 13.7428 10.021C13.8007 10.021 13.8543 10.0406 13.8974 10.0734L15.5624 11.287C15.684 11.3684 15.8293 11.4162 15.9855 11.4162C16.0788 11.4162 16.1677 11.3984 16.2506 11.3675L24.0804 7.80001C22.6769 6.10671 20.3655 5 17.7499 5C13.4696 5 10 7.96007 10 11.6118C10 13.6038 11.0439 15.3971 12.6778 16.6093C12.8088 16.7051 12.8947 16.8625 12.8947 17.0401C12.8947 17.0989 12.8824 17.1525 12.8674 17.2085C12.7369 17.7068 12.528 18.5049 12.5183 18.5423C12.502 18.6048 12.4766 18.6702 12.4766 18.7356C12.4766 18.8817 12.5922 19 12.7351 19C12.7911 19 12.8369 18.9786 12.8842 18.9508L14.5809 17.9479C14.7085 17.8727 14.8436 17.8258 14.9925 17.8258C15.0717 17.8258 15.1482 17.8384 15.2202 17.8609C16.0117 18.094 16.8656 18.2235 17.7499 18.2235C22.0299 18.2235 25.5 15.2633 25.5 11.6118C25.5 10.5057 25.1798 9.46407 24.6171 8.54777L15.6938 13.8223L15.637 13.8559Z",
    fill: "#1AAD19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeChat);
export default __webpack_public_path__ + "static/media/WeChat.5021913997d200d362a4a95f356594e7.svg";
export { ForwardRef as ReactComponent };